import "core-js/modules/es.array.every";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.object.values";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getMonthTargetCounter, getTotalCounter } from '@/api/bairun/financialCenter';
import dateUtils from '@/utils/dateUtil';
import NP from 'number-precision';
import { mapGetters } from 'vuex';
import moment from 'moment';
export default {
  name: 'SlotCounterStationSaleSheet',
  components: {},
  props: {
    start: {
      type: Number,
      required: true
    },
    end: {
      type: Number,
      required: true
    },
    totalId: {
      type: Number,
      default: 999
    },
    refIndex: {
      type: Number,
      required: true
    },
    totalCounterName: {
      type: String,
      default: ''
    },
    totalCounterDisplayName: {
      type: String,
      required: true
    },
    totalCounterAvgDisplayName: {
      type: String,
      required: true
    },
    sheetType: {
      type: String,
      required: true
    },
    totalCounterKind: {
      type: String,
      default: ''
    },
    slotCounterName: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      loading: false,
      slotOption: '',
      selectedArea: '全部',
      totalStats: null,
      slotStats: null,
      compareTotalStats: null,
      compareSlotStats: null,
      groupData: [],
      xAxisData: [],
      yAxisDatas: {},
      compareMapping: [],
      metricsArr: ['销量近期趋势'],
      borderFix: ['合计/L', '合/L', '0#'],
      filterMapping: [{
        text: '佛山',
        value: '佛山'
      }, {
        text: '粤西',
        value: '粤西'
      }, {
        text: '外省',
        value: '外省'
      }],
      showStations: [],
      customColors: [{
        color: '#909399',
        percentage: 30
      }, {
        color: '#f56c6c',
        percentage: 60
      }, {
        color: '#e6a23c',
        percentage: 85
      }, {
        color: '#409eff',
        percentage: 99
      }, {
        color: '#67c23a',
        percentage: 100
      }],
      stationTarget: []
    };
  },
  watch: {
    end: function end() {
      this.loadTarget(this.end);
      this.loadTotalData();
    },
    refIndex: function refIndex() {
      this.refIndexRefresh();
    }
  },
  computed: _objectSpread({}, mapGetters('stations', ['asyncStations'])),
  created: function created() {
    this.loadTarget(this.end);

    for (var i in this.asyncStations) {
      this.compareMapping.push({
        text: this.asyncStations[i]['statTag'],
        value: this.asyncStations[i]['ID'],
        sellerId: this.asyncStations[i]['ID']
      });
    }

    this.loadTotalData();
  },
  updated: function updated() {
    var _this = this;

    this.$nextTick(function () {
      _this.$refs['tableStationSale' + _this.sheetType].doLayout();
    });
  },
  methods: {
    refIndexRefresh: function refIndexRefresh() {
      this.$refs['tableStationSale' + this.sheetType].doLayout();
    },
    npPlus: function npPlus() {
      var res = 0;

      for (var i in arguments) {
        res = NP.plus(res, arguments[i]);
      }

      return res;
    },
    npPercent: function npPercent(a, b) {
      return NP.round(NP.times(NP.divide(NP.minus(Number(a), Number(b)), b), 100), 2);
    },
    filterHandler: function filterHandler(value, row, column) {
      for (var i in this.asyncStations) {
        if (this.asyncStations[i]['ID'] === row['sellerId'] && this.asyncStations[i]['statArea'] === value) {
          return true;
        }
      }

      return false;
    },
    filterChange: function filterChange(selected) {
      this.selectedArea = selected['area'] && selected['area'][0] ? selected['area'][0] : '全部';
    },
    progressFormat: function progressFormat(value) {
      return function () {
        return value + '%';
      };
    },
    cellStyle: function cellStyle(_ref) {
      var row = _ref.row,
          column = _ref.column;

      if (this.borderFix.includes(column.label)) {
        return 'border-right:1px solid #000000';
      }
    },
    getSummaries: function getSummaries(param) {
      var columns = param.columns,
          data = param.data;
      var sums = [];

      var _that = this;

      var endYearValue = _that.timestamp2beforeyeardatestring(this.end / 1000, 'YYYY', 1);

      var endMonthValue = _that.timestamp2beforemonthdatestring(this.end / 1000, 'YYYYMM', 1);

      var cSheetType = this.sheetType;
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = '合计/L';
          return;
        }

        var values;

        if (column.property === 'circleAmount92') {
          values = data.map(function (item) {
            return _that.sellerMonthAvg(cSheetType, item['sellerId'], endYearValue);
          });
        } else if (column.property === 'circleAmount95') {
          values = data.map(function (item) {
            return _that.sellerMonthAvg(cSheetType, item['sellerId'], endMonthValue);
          });
        } else {
          values = data.map(function (item) {
            return Number(item[column.property]);
          });
        }

        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = values.reduce(function (prev, curr) {
            var value = Number(curr);

            if (!isNaN(value)) {
              return NP.plus(prev, curr);
            } else {
              return prev;
            }
          }, 0);
          sums[index] = NP.round(sums[index], 2);
        } else {
          sums[index] = 'N/A';
        }
      });
      sums[5] = sums[2] > 0 ? NP.round(NP.times(NP.divide(NP.minus(sums[4], sums[2]), sums[2]), 100), 2) + '%' : '-';
      return sums;
    },
    numberFix: function numberFix(number, len) {
      return dateUtils.numberFix(number, len);
    },
    showDetail: function showDetail(number, len) {
      return dateUtils.numberFix(number, len);
    },
    sellerName: function sellerName(sellerId) {
      for (var i in this.asyncStations) {
        if (this.asyncStations[i].ID === sellerId) {
          return this.asyncStations[i]['statAbbr'];
        }
      }

      return '';
    },
    sellerMonthAvg: function sellerMonthAvg(type, sellerId, month) {
      if (!this.stationTarget || this.stationTarget.length === 0) {
        return 0;
      }

      for (var i in this.stationTarget) {
        if (this.stationTarget[i]['stationId'] === sellerId) {
          return month.length < 5 ? this.stationTarget[i]['lastYear' + type.replace(/^\S/, function (s) {
            return s['toUpperCase']();
          }) + 'Avg'] : this.stationTarget[i]['lastMonth' + type.replace(/^\S/, function (s) {
            return s['toUpperCase']();
          }) + 'Avg'];
        }
      }

      return 0;
    },
    sellerTarget: function sellerTarget(sellerId, month) {
      if (!this.stationTarget || this.stationTarget.length === 0) {
        return 0;
      }

      for (var i in this.stationTarget) {
        if (this.stationTarget[i]['stationId'] === sellerId) {
          return this.stationTarget[i]['target'];
        }
      }

      return 0;
    },
    loadTarget: function loadTarget(datetime) {
      var _this2 = this;

      getMonthTargetCounter({
        'month': moment(datetime).format('YYYYMM')
      }).then(function (response) {
        _this2.stationTarget = response.data;
      });
    },
    loadTotalData: function loadTotalData() {
      var _this3 = this;

      if (this.loading) {
        return;
      }

      this.loading = true;
      var descriptorData = {
        descriptors: [{
          type: 'ocosotpc',
          operator: 'dateOCOSOTPC',
          name: this.slotCounterName,
          start: this.end / 1000 - 24 * 60 * 60,
          end: this.end / 1000,
          search: this.totalId === 999 ? '' : this.totalId.toString()
        }]
      };
      getTotalCounter(descriptorData).then(function (response) {
        var tempGroupData = Object.values(response.data);
        _this3.groupData = tempGroupData.sort(function (a, b) {
          var orders = [10006, 10003, 10011, 10013, 10010, 10014, 10001, 10012, 10002, 10005, 10004, 10009, 10008, 10015]; // // console.log('sort orders', orders.indexOf(a.sellerId), orders.indexOf(b.sellerId))

          return orders.indexOf(a.sellerId) - orders.indexOf(b.sellerId);
        });
        _this3.loading = false;

        _this3.$refs['tableStationSale' + _this3.sheetType].doLayout();
      }).catch(function () {
        _this3.loading = false;
      });
    },
    timestamp2datestring: function timestamp2datestring(ts) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      return dateUtils.timeStampToString(ts, format);
    },
    timestamp2beforemonthdatestring: function timestamp2beforemonthdatestring(ts) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      return dateUtils.timeStampToBeforeMonthString(ts, format, n);
    },
    timestamp2beforeyeardatestring: function timestamp2beforeyeardatestring(ts) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      return dateUtils.timeStampToBeforeYearString(ts, format, n);
    },
    totalColumn: function totalColumn(ts) {
      if (!this.totalStats || this.totalStats[ts] === undefined) {
        return 0;
      } else {
        return this.numberFix(this.totalStats[ts], 2);
      }
    }
  }
};